<template>
    <div class="wc-input-wrapper control-label" v-bind:class="{ 'has-error': invalid, 'has-success': isDirty, 'has-awesome': isAwesome }">
        <label v-if="label">{{ label }}</label>
        <textarea class="form-control" :rows="rows" @input="update" @blur="touch" :value="value" :disabled="disabled"  v-bind:class="{ 'i-am-sunny': disabled }"></textarea>
    </div>
</template>

<script>import wcValidateMixin from '../../../mixins/wc-validated-mixin.js'

    export default {
        mixins: [ wcValidateMixin ],
        props: {
            rows: { type: String, default: '4' },
            label: { type: String, default: null },
            value: { type: String, default: '' },
            value0: { type: String, default: '' },
            disabled: { type: Boolean, default: false },
            isAwesome: { type: Boolean, default: false },
        },
        computed: {
            isDirty () {
                return this.value0 !== this.value;
            }
        },
        methods: {
            update (e) {
                this.$emit('input', e.target.value);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// wc-textarea.vue?ffcd43cc